import React from "react";
import Stock from "./Components/Stock";
import Approvals from "./Components/Approvals";
import PoSupplier from "./Components/PoSupplier";
import PurchaseOrderSupplier from "./Components/PurchaseOrderSupplier";
import OrderReceived from "./Components/OrderReceived";
import OrderDelived from "./Components/OrderDelived";
import Request from "./Components/Request";
import Returns from "./Components/Returns";

function StoreIndex() {
  return (
    <div className="w-full space-y-4 pb-6">
      {/* Top KPI & Approvals Header Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 items-stretch">
        <div className="lg:col-span-1">
          <Stock />
        </div>
        <div className="lg:col-span-2">
          <Approvals />
        </div>
      </div>

      {/* Supplier & Purchase Orders Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-4">
        <div className="lg:col-span-2">
          <PoSupplier />
        </div>
        <div className="lg:col-span-3">
          <PurchaseOrderSupplier />
        </div>
      </div>

      {/* Orders Movement Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <OrderReceived />
        <OrderDelived />
      </div>

      {/* Issuance Requests & Returns Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <Request />
        <Returns />
      </div>
    </div>
  );
}

export default StoreIndex;